/**
 * @generated SignedSource<<46be6a8c569876adba02c78aa1b84184>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddIHKCertificateBundleRewardInput = {
  bundleIds: ReadonlyArray<string>;
  clientMutationId?: string | null;
  contentId: string;
};
export type createIhkCertificateRewardBundleButton_AddIHKCertificateRewardBundleMutation$variables = {
  input: AddIHKCertificateBundleRewardInput;
};
export type createIhkCertificateRewardBundleButton_AddIHKCertificateRewardBundleMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly addIHKCertificateBundleReward: {
        readonly content: {
          readonly " $fragmentSpreads": FragmentRefs<"rewardEditor_TreeNodeFragment">;
        };
      } | null;
    };
  };
};
export type createIhkCertificateRewardBundleButton_AddIHKCertificateRewardBundleMutation = {
  response: createIhkCertificateRewardBundleButton_AddIHKCertificateRewardBundleMutation$data;
  variables: createIhkCertificateRewardBundleButton_AddIHKCertificateRewardBundleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createIhkCertificateRewardBundleButton_AddIHKCertificateRewardBundleMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddIHKCertificateBundleRewardPayload",
                "kind": "LinkedField",
                "name": "addIHKCertificateBundleReward",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "rewardEditor_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createIhkCertificateRewardBundleButton_AddIHKCertificateRewardBundleMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddIHKCertificateBundleRewardPayload",
                "kind": "LinkedField",
                "name": "addIHKCertificateBundleReward",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "rewards",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isReward"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ExternalLicenseRewardData",
                                        "kind": "LinkedField",
                                        "name": "data",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ExternalLicensePool",
                                            "kind": "LinkedField",
                                            "name": "pool",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ExternalLicensePoolData",
                                                "kind": "LinkedField",
                                                "name": "data",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "name",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              (v2/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "superId",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ExternalLicenseReward",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "bundleIds",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "IHKCertificateBundle",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ContentTypeDefinition",
                            "abstractKey": "__isContentTypeDefinition"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "rewards",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ELearningContentTypeDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8169a25a87169e00c1c55459fd8fe32f",
    "id": null,
    "metadata": {},
    "name": "createIhkCertificateRewardBundleButton_AddIHKCertificateRewardBundleMutation",
    "operationKind": "mutation",
    "text": "mutation createIhkCertificateRewardBundleButton_AddIHKCertificateRewardBundleMutation(\n  $input: AddIHKCertificateBundleRewardInput!\n) {\n  Admin {\n    Tree {\n      addIHKCertificateBundleReward(input: $input) {\n        content {\n          ...rewardEditor_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment createExternalLicenseRewardButton_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      rewards {\n        __typename\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment createIhkCertificateRewardBundleButton_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      rewards {\n        __typename\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment createIhkCertificateRewardButton_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      rewards {\n        __typename\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment externalLicenseRewardForm_ExternalLicenseRewardFragment on ExternalLicenseReward {\n  ... on Reward {\n    __isReward: __typename\n    id\n  }\n  superId\n  data {\n    pool {\n      id\n      data {\n        name\n      }\n    }\n  }\n}\n\nfragment ihkCertificateRewardBundleForm_IHKCertificateRewardBundleFragment on IHKCertificateBundle {\n  id\n  bundleIds\n}\n\nfragment rewardEditor_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      rewards {\n        __typename\n        id\n        kind\n        ... on ExternalLicenseReward {\n          data {\n            pool {\n              data {\n                name\n              }\n              id\n            }\n          }\n        }\n        ...rewardForm_RewardFragment\n      }\n    }\n  }\n  ...rewardForm_TreeNodeFragment\n  ...createExternalLicenseRewardButton_TreeNodeFragment\n  ...createIhkCertificateRewardButton_TreeNodeFragment\n  ...createIhkCertificateRewardBundleButton_TreeNodeFragment\n}\n\nfragment rewardForm_RewardFragment on Reward {\n  __isReward: __typename\n  id\n  kind\n  ... on ExternalLicenseReward {\n    ...externalLicenseRewardForm_ExternalLicenseRewardFragment\n  }\n  ... on IHKCertificateBundle {\n    ...ihkCertificateRewardBundleForm_IHKCertificateRewardBundleFragment\n  }\n}\n\nfragment rewardForm_TreeNodeFragment on TreeNode {\n  id\n}\n"
  }
};
})();

(node as any).hash = "d7bfe7a96e9a67df9ae2eea56f471482";

export default node;
